import React from 'react';
import FilterSection from '@client/components/search/FilterSection';
import {
  ALL_FILTER_CONFIGS,
  BASIC_FILTER_CONFIGS,
  DOCUMENT_TYPE,
} from '@client/feature/activeSubstance/config/filterConfigs';

const BasicFilters = ({ filters, onFilterChange, filterLabels }) => {
  return (
    <FilterSection
      filterConfigs={BASIC_FILTER_CONFIGS}
      allFilterConfigs={ALL_FILTER_CONFIGS}
      filters={filters}
      onFilterChange={onFilterChange}
      document={DOCUMENT_TYPE}
      filterLabels={filterLabels}
    />
  );
};

export default BasicFilters;
